import { colors, fontSizes } from "@hubrise/react-components"
import styled from "styled-components"

export const Main = styled.div`
  max-width: 60rem;
  margin: 0 auto;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;
`

export const Title = styled.div`
  line-height: 2rem;
  color: ${colors.textDark};
  font-size: ${fontSizes._19};
  font-weight: 300;
`

export const Controls = styled.div`
  display: flex;
  flex-flow: row;
  align-items: baseline;
  gap: 1em;
`
